import {stringify} from 'qs'
import request from '../utils/request'
import api from '../common/api/auth'

export async function init(params) {
    return request(`${api.init.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function login(payload) {
    return request(api.login.url, {
        method: api.login.type,
        body: payload.body,
    })
}

export async function logout() {
    return request(api.logout.url, {
        method: api.logout.type,
    })
}
